module.exports = __webpack_public_path__ + "img/login-hero-desktop-2.3e0ceddc.jpg";